(ns ycweb.app.website.voucher.voucher
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.voucher.balance]
   [ycweb.app.website.voucher.balance-show]
   [ycweb.app.website.voucher.create]
   [ycweb.app.website.voucher.design]
   [ycweb.app.website.voucher.preview]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc voucher < rum/reactive [app-atom]
  [:<>
   [:div
    {:class (u/bem :yc-page-content [:standard])}
    [:div
     {:class (u/bem :yc-section [:standard])}
     [:header.yc-intro-text
      (headings/heading "Yuppiechef Gift Vouchers"
        {:type :h1
         :size :large
         :center true})
      [:p.yc-paragraph
       "Create and send a Yuppiechef Gift Voucher by email or choose to print at home."]]]
    [:div
     {:class (u/bem :yc-section [:large])}
     [:nav.flex-grid-group
      [:div
       {:class (u/bem :flex-grid-block [:m-1-2])}
       [:div.voucher-choice.card.flex-grid-content
        [:a.block-link
         (urlstate/href-props app-atom "gift-vouchers" "choosecover" {:method "email"})
         [:div.voucher-choice__hero
          (web-common/lazy-image app-atom
            "pages/gift-vouchers/voucher-choice-email"
            {:class ["yc-simple-image  yc-simple-image--full"]}
            {:w 490
             :q "auto"
             :dpr 2
             :alt "Email a Yuppiechef Gift Voucher"})]
         [:div.voucher-choice__content
          (headings/heading "Email a Gift Voucher"
            {:type :h2
             :size :medium
             :flush true
             :center true})
          [:div.u-max-width-320.u-block-center
           [:p.u-text-center
            {:class (u/bem :yc-paragraph [:small])}
            "Create a voucher and send it by email, either immediately or on a specific date."]]
          [:div.voucher-choice__button-wrapper
           (buttons/button-web "Create voucher"
             (merge
               (urlstate/href-props app-atom "gift-vouchers" "choosecover" {:method "email"})
               {:type :span-button
                :style :primary}))]]]]]
      [:div
       {:class (u/bem :flex-grid-block [:m-1-2])}
       [:div.voucher-choice.card.choice-card.flex-grid-content
        {:data-choice-card "Or"}
        [:a.block-link
         (urlstate/href-props app-atom "gift-vouchers" "choosecover" {:method "pdf"})
         [:div.voucher-choice__hero
          (web-common/lazy-image app-atom
            "pages/gift-vouchers/voucher-choice-print-base"
            {:class ["yc-simple-image  yc-simple-image--full"]}
            {:w 490
             :q "auto"
             :alt ""})
          (web-common/lazy-image app-atom
            "pages/gift-vouchers/voucher-choice-print"
            {:class ["voucher-choice__image-layer"]}
            {:w 490
             :q "auto"
             :dpr 2
             :alt "Email a Yuppiechef Gift Voucher"})]
         [:div.voucher-choice__content
          (headings/heading "Print a Gift Voucher"
            {:type :h2
             :size :medium
             :flush true
             :center true})
          [:div.u-max-width-320.u-block-center
           [:p.u-text-center
            {:class (u/bem :yc-paragraph [:small])}
            "Create a voucher and print it at home as a card to give to someone in person."]]
          [:div.voucher-choice__button-wrapper
           (buttons/button-web "Create voucher"
             (merge
               (urlstate/href-props app-atom "gift-vouchers" "choosecover" {:method "pdf"})
               {:type :span-button
                :style :primary}))]]]]]]]
    [:div
     {:class (u/bem :yc-section [:large])}
     [:div.u-block-center.u-max-width-480
      [:p.u-text-center
       {:class (u/bem :yc-paragraph [:large])}
       "Already have a Gift Voucher or Card and want to check your balance?"]
      [:div.u-block-center.u-max-width-240.u-margin-top-10
       (buttons/button-web "Check Voucher Balance"
         (merge
           (urlstate/href-props app-atom "gift-vouchers" "balance")
           {:style :secondary
            :full true}))]]]]])

(defmethod flow/render-screen :web.gift-vouchers [app-atom _]
  (website/screen-wrapper app-atom
    (voucher app-atom)
    {}))